import React, { useEffect } from "react";
import { useSoftUIController, setLayout } from "context";
import { useLocation } from "react-router-dom";

import SuiBox from "components/SuiBox";
import Footer from "examples/Footer";

const Layout = ({ children }) => {
  const [controller, dispatch] = useSoftUIController();
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "login");
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <div className="grid grid-cols-1 grid-rows-1 min-h-screen">
        <div
          className="flex flex-col items-center"
          style={{
            background: "linear-gradient(73.29deg, #39475E 0%, #BCC9DA 100%)",
          }}
        >
          {children}
          <SuiBox display="flex" justifyContent="center" alignItems="center" mb={2}>
            <Footer color="white" />
          </SuiBox>
        </div>
      </div>
    </div>
  );
};

export default Layout;
